
import { NgSelectModule } from '@ng-select/ng-select';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Component, inject } from '@angular/core';
import { fromEvent } from "rxjs";
import { TranslateService } from '@ngx-translate/core';
import { OTHERS } from '@riise/shared/utils/constants/others';
import { MaintenanceService } from '@riise/core/services/maintenance/maintenance.service';
import { ClosuresService } from '@riise/core/services/closures/closures.service';
import { ɵɵRouterOutlet } from "@angular/router/testing";


@Component({
  selector: 'app-root',
  imports: [NgSelectModule, NgScrollbarModule, NgbModule, ɵɵRouterOutlet],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

    private translateService = inject(TranslateService);
    maintenanceService = inject(MaintenanceService);
    closuresService = inject(ClosuresService);


    title = 'riise';
    DEFAULT_LANG = OTHERS.DEFAULT_LANG
    SUPPORTED_LANGS = OTHERS.SUPPORTED_LANGS
    endDate : any

    ngOnInit() {
        fromEvent(window, 'load').subscribe(() => document.querySelector('#glb-loader')?.classList.remove('loaderShow'));
        this.initializeLanguage()
        this.getClosureActive()
    }

    constructor() {}



    private initializeLanguage() {
        const savedLang = localStorage.getItem('lang');
        const browserLang = this.translateService.getBrowserLang();

        let languageToUse: string;

        if (savedLang && this.SUPPORTED_LANGS.includes(savedLang)) {
          languageToUse = savedLang;
          this.translateService.setDefaultLang(languageToUse)
        } else if (browserLang && this.SUPPORTED_LANGS.includes(browserLang)) {
          languageToUse = browserLang;
          localStorage.setItem('lang', browserLang);
          this.translateService.setDefaultLang(languageToUse)
        } else {
          languageToUse = this.DEFAULT_LANG;
          this.translateService.setDefaultLang(languageToUse)
          localStorage.setItem('lang', this.DEFAULT_LANG);
        }

        this.translateService.use(languageToUse);
    }


    getClosureActive(): void {
      this.closuresService.getClotureActive(true).subscribe(
        (result: any) => {
            this.endDate = result?.data?.closures?.edges[0]?.node?.endDate
            this.closuresService.setCloture(this.endDate);
        },(error)=>{
            this.endDate = null;
        })
    }


}
